import LoadTimeline from '../base/load-timeline';
import Action from "../base/action";
import {TriggerTypeEnum} from "../base/training-literals";

function shouldExecuteLoadTimeline(loadTimelines) {
    if (!loadTimelines) return false;
    const triggerType = loadTimelines.triggerType ?? TriggerTypeEnum.TIMELINE;
    if (triggerType === TriggerTypeEnum.EVENT) {
        return Array.isArray(loadTimelines.events) && loadTimelines.events.length > 0;
    }
    return Array.isArray(loadTimelines.timelines) && loadTimelines.timelines.length > 0;
}

class TextInput extends Action {
    inputVariable;
    loadTimelines;
    cancelTimelines;

    constructor(props) {
        super(props);
        this.inputVariable = props.inputVariable || "";
        this.loadTimelines = props.loadTimelines || {
            timelines: [],
            events: [],
            triggerType: TriggerTypeEnum.TIMELINE,
            prune: {}
        };
        this.cancelTimelines = props.cancelTimelines || {
            timelines: [],
            events: [],
            triggerType: TriggerTypeEnum.TIMELINE,
            prune: {}
        };
    }

    async execute(eventLoop) {
        let self = this;
        let keyboardCallbacks = {};

        const enterCallback = (text) => {
            if (!text.trim().length) {
                VRMessageController.addMessage({text: 'Can not input empty value for a variable', priority: VrMessagePriorityEnum.HIGHPRIORITYINFO});
                keyboardController.changeTextFieldVisibility(false);
                keyboardController.toggleState(keyboardController.getVRKeyboardParent(), keyboardCallbacks);
                return;
            }

            eventLoop.training.registry.set(self.inputVariable, text);
            if (shouldExecuteLoadTimeline(self.loadTimelines)) {
                const loadTimeline = new LoadTimeline({
                    timelines: self.loadTimelines.timelines || [],
                    events: self.loadTimelines.events || [],
                    triggerType: self.loadTimelines.triggerType ?? TriggerTypeEnum.TIMELINE,
                    prune: self.loadTimelines.prune || {}
                });
                loadTimeline.execute(eventLoop);
            }
        };

        const cancelCallback =  () => {
            if (shouldExecuteLoadTimeline(self.cancelTimelines)) {
                const loadTimeline = new LoadTimeline({
                    timelines: self.cancelTimelines.timelines || [],
                    events: self.cancelTimelines.events || [],
                    triggerType: self.cancelTimelines.triggerType ?? TriggerTypeEnum.TIMELINE,
                    prune: self.cancelTimelines.prune || {}
                });
                loadTimeline.execute(eventLoop);
            }
        };

        keyboardCallbacks.enterCallback = enterCallback;
        keyboardCallbacks.cancelCallback = cancelCallback;
        keyboardController.toggleState(keyboardController.getVRKeyboardParent(), keyboardCallbacks);
    }
}

export default TextInput;